import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateOrderStatus,
  user_order_details,
} from "../../../api/user/order";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  oderdetailLoading,
} from "../../../reducers/users/order";
import CancelOrderModal from "../../modal/CancelOrderModal";

const CancelOrder = () => {

  const param = useParams();
  const dispatch = useDispatch();
  
  const [formData, setFormData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const cancelOrderModal = () => {
    setVisible(true);
  };

  const cancelOrder = () => {
    if (!formData) {
      toast.warn("Please write the reason for cancellation!");
      return false;
    }
    setIsLoading(true);
    const apiData = {
      orderId: param?.id,
      cancelOrderReason: formData,
      orderStatus: 2,
    };
    dispatch(updateOrderStatus(apiData))
      .then((res) => {
        if (res?.statusCode === 200)
          toast.success("Order Cancelled Successfully.");
        setIsLoading(false);
        setVisible(false);
        dispatch(oderdetailLoading(true));
        const apiData = {
          orderId: param?.id,
        };
        dispatch(user_order_details(apiData)).then((res) => {
          if (res.statusCode === 200) {
            dispatch(oderdetailLoading(false));
          }
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div>
      <div className="row my-5">
        <div className="col-md-9">
          <textarea
            className="form-control"
            cols="50"
            placeholder="Reason for Cancellation"
            rows="7"
            onChange={(e) => setFormData(e.target.value)}
          ></textarea>
        </div>
        <div className="col-md-3 align-self-center">
          <div className="text-center ">
            <button
              className="ad-bg-primary btn mx-3 ad-text-secondary px-4"
              onClick={() => cancelOrderModal()}
            >
              Cancel Order
            </button>
          </div>
        </div>
      </div>

      <CancelOrderModal
        visible={visible}
        header={"Cancel Order"}
        setVisible={() => setVisible(false)}
        footer={false}
        cancelOrder={cancelOrder}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CancelOrder;
